/* eslint-disable */
import React from 'react'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import moment from 'moment'

import { ShowResultsInput, ShowResultsFormWrapper } from './styles'

const diaDaSemanaMap = [
    {
      value: 6,
      label: 'Dom',
    },
    {
      value: 0,
      label: 'Seg',
    },
    {
      value: 1,
      label: 'Ter',
    },
    {
      value: 2,
      label: 'Qua',
    },
    {
      value: 3,
      label: 'Qui',
    },
    {
      value: 4,
      label: 'Sex',
    },
    {
      value: 5,
      label: 'Sab',
    },
  ]

const getChoosenDays = (days) => {
    if (days === undefined|| days.length === 7) return 'Todos os dias'
    const foundDays = diaDaSemanaMap.filter((dia => {
        const found = days.find(day => {
            return day === dia.value
        })
        return found !== undefined
    }))

    const stringOfDays = foundDays.map(day => day.label).toString()
    return stringOfDays
}

const getPeriodo = (periodo, rangeDates) => {
    if (rangeDates) {
        return `${moment(rangeDates.from).format('MM/DD')} a ${moment(rangeDates.to).format('MM/DD')} de ${moment(rangeDates.from).format('YYYY')}`
     }
    if (!periodo) return '90 dias' 
    return `${periodo} dias`  
}

const getTipoTransacao = (tipoTransacao) => {
    if (!tipoTransacao || tipoTransacao.length === 0) return 'Todos os tipos'
    if (tipoTransacao && tipoTransacao.length === 2) return 'Todos os tipos'
    return { PEDAGIO: 'Pedágio', ESTACIONAMENTO: 'Estacionamento'}[tipoTransacao[0].tipo]
}

const getQuantidade = (quantidade) => {
    if(!quantidade) return '30 transações'
    return `${quantidade} transações`
}

function ShowResultsForm({ tipoTransacao, rangeDates, periodo, quantidade, diaDaSemana}) {
    return (
      <ShowResultsFormWrapper>
        <ShowResultsInput placeholder={getTipoTransacao(tipoTransacao)} disabled />
        <ShowResultsInput placeholder={getPeriodo(periodo, rangeDates)} disabled/>
        <ShowResultsInput placeholder={getChoosenDays(diaDaSemana)} disabled/>
        <ShowResultsInput placeholder={getQuantidade(quantidade)} disabled/>
      </ShowResultsFormWrapper>
        
  )
}

const mapStateToProps = state => {
  const selector = formValueSelector('statementsFilter')
  return {
    tipoTransacao: selector(state, 'type'),    
    periodo: selector(state, 'periodo'),
    quantidade: selector(state, 'quantidade'),
    diaDaSemana: selector(state, 'diaDaSemana'),
    rangeDates: selector(state, 'rangeDates')
  }
}

export default connect(mapStateToProps)(ShowResultsForm)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerFilterForm/ShowResultsForm.js